import {
	Accordion,
	AccordionDetails,
	AccordionSummary
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React from "react";
import {
	SearchBox
} from "react-instantsearch/dom";
import FilterBay from "./filter";

export default function SearchBar() {
	return (
		<div className="search-wrapper">
			<div id="ais-search-box " className="ais-search-box w-embed ">
				<SearchBox
					translations={{ placeholder: "Search The Brain 🔍 " }}
					searchAsYouType={false}
				/>


				<Accordion style={{background:"transparent", border:"none", boxShadow:"none"}} elevation={0}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1a-content"
						id="panel1a-header"

					>
						<h5 style={{ margin: "0 auto" }}>Additional Filters (Click Here)</h5>
					</AccordionSummary>

					<AccordionDetails>
						<FilterBay />
					</AccordionDetails>
				</Accordion>
			</div>
		</div>
	);
}
